import { useMemo } from 'react'
import CruisePriceDetails from './CruisePriceDetails'
import getValueOffPercent from 'lib/offer/getValueOffPercent'
import { OFFER_TYPE_HOTEL } from 'constants/offer'

interface Props {
  offer: App.Offer | App.OfferSummary
  className?: string
  variant?: 'default' | 'condensed'
  showViewButton?: boolean
}

function CruiseFlashPriceDetails({ offer, variant = 'default', showViewButton = true }: Props) {
  const pkg = offer.lowestPricePackage!
  const propertyFees = pkg.propertyFees
  const totalPrice = pkg.price + propertyFees
  const totalValue = pkg.value + propertyFees
  const valueOffPercent = getValueOffPercent(totalValue, totalPrice)

  const priceDetails = useMemo<App.Pricing>(() => {
    const shouldShowValue = pkg.value > 0 && totalValue > totalPrice && pkg.shouldDisplayValue &&
      (offer.type == OFFER_TYPE_HOTEL || !pkg.roomRate?.inclusionsHideValue)
    const pricing: App.Pricing = {
      price: totalPrice,
      saleUnit: offer.saleUnit,
      fees: [{ type: 'property', amount: propertyFees }],
    }
    if (shouldShowValue) {
      return {
        ...pricing,
        value: Math.ceil(totalValue),
        discountPercent: valueOffPercent,
      }
    }
    return pricing
  }, [offer.saleUnit, offer.type, pkg, propertyFees, totalPrice, totalValue, valueOffPercent])

  return <CruisePriceDetails
    offerId={offer.id}
    isFlash
    priceDetails={priceDetails}
    roomOccupancy={pkg.roomOccupancy}
    variant={variant}
    showViewButton={showViewButton}
  />
}

export default CruiseFlashPriceDetails
